export enum UpdateVirtualCardScreen {
  Pick,
  Standard,
  Recurring,
  GuestAccess,
  RecurringGuest,
  BillPay,
  DecliningBalance,
  IssuerCycle,
}
